export default "__VITE_ASSET__Ie6B$i9g__"